/* import __COLOCATED_TEMPLATE__ from './email-section.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsContactInfoEmailSection extends Component {
  get emailIsRequired() {
    if (this.connection.isCouple) return true;

    if (this.emailTypeAttr === 'emailType') return this.#primaryEmailRequirements;

    return this.connection.isRequiredEmergencyContactEmailAddress;
  }

  get #primaryEmailRequirements() {
    return !this.connection.isMinor;
  }
}
